<template>
  <div>
    <DialogContainer v-model="dialogObj">
      <template v-slot:dialogSlot>
        <div class="business-body custom-form">
          <!-- 日历 -->
          <div v-loading="loading" style="position:relative;">
            <div class="dot-detail">
              <div class="detail-box">
                <span class="value-text">{{ formatDate }}</span>
              </div>
              <div class="detail-box">
                <span class="label-text">出勤</span>
                <span class="value-text">{{detail.attendanceNum}}人</span>
              </div>
              <div class="detail-box">
                <span class="label-text">不出勤</span>
                <span class="value-text">{{detail.notAttendanceNum}}人</span>
              </div>
              <div class="detail-box">
                <span class="label-text">未排班</span>
                <span class="value-text">{{detail.unSchedulingNum}}人</span>
              </div>
            </div>
          </div>
          <div class="search-form-box">
            <el-row :gutter="30">
              <el-form inline>
                <el-col :span="6">
                  <el-form-item label="服务商:">
                    <el-select
                      style="width: 100%"
                      :clearable="false"
                      v-model="searchForm.companyId"
                      placeholder="请选择">
                      <el-option
                        v-for="item in supplierData"
                        :key="item.companyId"
                        :label="item.companyName"
                        :value="item.companyId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="司机姓名:">
                    <el-input style="width: 100%" clearable v-model="searchForm.keyword" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="排班状态:">
                    <el-select style="width: 100%" clearable v-model="searchForm.schedulingStatus" placeholder="请选择">
                      <el-option
                        v-for="item in $dict.schedulingStatusOptions"
                        :key="item.dictCode"
                        :label="item.dictLabel"
                        :value="item.dictCode"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="">
                    <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                    <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
          </div>
          <div class="custom-table-box">
            <custom-table
              :data="tableData"
              :column="tableColumn"
              :total="tableOptions.total"
              :loading="tableOptions.loading"
              :page="tableOptions.pageNumber"
              :size="tableOptions.pageSize"
              :selection="false"
              @pagination="handleSizeChange">
              <template v-slot:schedulingStatus="{ row }">
                <span style="color: #e6a23c" v-if="row.schedulingStatus === 0">待排班</span>
                <span style="color: #67c23a" v-if="row.schedulingStatus === 1">出勤</span>
                <span style="color: #f56c6c" v-if="row.schedulingStatus === 2">不出勤</span>
              </template>
              <template v-slot:operation="{ row }">
                <span class="operate-btn" @click.stop="handlePaiBan(row)">排班</span>
              </template>
            </custom-table>
          </div>
        </div>
      </template>
    </DialogContainer>
    <addOrEdit ref="addOrEdit"></addOrEdit>
  </div>
</template>

<script>
import addOrEdit from "./addOrEdit.vue";
import DialogContainer from "@/components/Dialog.vue";
import {getCalendarDetail, getCalendarOverview, getDriverScheduling, getPage, schedulingDriver} from "./api";
import CustomTable from "@/components/CustomTable.vue";
import tableMixin from "@/mixin/tableMixin";
import dayjs from 'dayjs'
// 引入星期汉化
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')
export default {
  mixins: [tableMixin],
  name: "AddOrEdit",
  components: {
    CustomTable,
    DialogContainer,
    addOrEdit,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "60%",
        show: false,
        title: "排班信息",
        closeOnClickModal: false,
        confirmFn: "",
        beforeClose: (v) => {
          this.searchForm.companyId = ""
          this.searchForm.day = ""
          this.searchForm.schedulingStatus = ""
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      getTableMethod: getCalendarDetail,
      searchForm: {
        "companyId": "",
        "keyword": "",
        "day": "",
        "schedulingStatus": ""
      },
      tableColumn: [
        {
          label: "服务商",
          prop: "companyName",
          show: true,
        },
        {
          label: "司机姓名",
          prop: "driverName",
          show: true,
        },
        {
          label: "排班状态",
          prop: "schedulingStatus",
          scopeStatus: true,
          show: true,
        },
        {
          label: "排班调度",
          prop: "orderDispatcherName",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "120px",
          scopeStatus: true,
          show: true,
        },
      ],
      supplierData: [],
      detail: {},
      carImage: require("@/assets/imgs/title.png"),
      loading: false,
      isImmediatelyGetData: false,
      show: false
    };
  },
  computed: {
    formatDate: function () {
      return dayjs(this.searchForm.day).format('YYYY年MM月DD日 dddd')
    }
  },
  mounted() {},
  methods: {
    handleAddOrEditSuccess() {
      this.getDetail()
      this.getTableData()
      this.$emit("success")
    },
    handleReset() {
      // this.searchForm.companyId = ""
      this.searchForm.schedulingStatus = ""
      this.searchForm.keyword = ""
      this.tableOptions.currentPage = 1
      this.getTableData()
    },
    handlePaiBan(row) {
      let obj = Object.assign({}, row, {scheduledDate: this.searchForm.day});
      this.$refs.addOrEdit.init(obj, row.driverId, row.dispatcherId);
    },
    async init(item,supplierData, companyId) {
      this.supplierData = supplierData;
      this.searchForm.day = item.date;
      this.searchForm.companyId = companyId;
      this.dialogObj.show = true;
      await this.getDetail();
      await this.getTableData();
    },
    getDetail() {
      this.loading = true
      getCalendarOverview({
        companyId: this.searchForm.companyId,
        keyword: this.searchForm.keyword,
        day: this.searchForm.day,
      }).then((res) => {
        if (res.code === 200) {
         this.detail = res.data;
        }
      }).finally(()=>{
        this.loading = false
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .left-box {
    padding-right: 0.5rem;
    padding-bottom: 0.1rem;
    position: relative;
    display: flex;
    align-items: center;
    .left-box-top {
      display: flex;
      align-items: center;
      .label {
        width: 0.2rem;
        height: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.02rem;
        font-size: 0.12rem;
      }
      .zhuang {
        color: #5cc41a;
        background-color: rgba(92, 196, 26, 0.3);
      }
      .xie {
        color: #e52019;
        background-color: rgba(229, 32, 25, 0.3);
      }
      .name {
        color: #000000;
        font-size: 0.18rem;
        line-height: 0.2rem;
        padding-left: 0.04rem;
      }
    }
    .date {
      color: #8c8c8c;
      font-size: 0.12rem;
      line-height: 0.2rem;
    }
  }
  .left-box:nth-last-of-type(1)::before {
    display: none;
  }
  .car-img {
    width: 0.1rem;
    height: 0.1rem;
    margin-right: 0.04rem;
  }
  .center-box-2 {
    display: flex;
    align-items: center;
    line-height: 0.24rem;
    color: #000000;
    font-size: 0.12rem;
    position: relative;
  }
  .center-box-2 {
    padding-left: 0.2rem;
    position: relative;
    &::before {
      content: "";
      width: 0.01rem;
      height: 0.1rem;
      background-color: #dce5f5;
      position: absolute;
      left: 0.1rem;
    }
  }
  .center-box-1 {
    color: #1269ff;
  }
}
.list-box {
  background: #f7fbff;
  border-radius: 0.08rem;
  padding: 0.1rem;
  box-sizing: border-box;
  margin-top: 0.2rem;
  .list-bottom {
    width: 100%;
    display: flex;
    padding: 0.08rem 0;
    .list-bottom-box {
      width: 25%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .list-image {
        width: 0.85rem;
        height: 0.5rem;
        border-radius: 0.05rem;
      }
      .bottom-box-name {
        color: #8c8c8c;
        font-size: 0.12rem;
        margin-bottom: 0.06rem;
      }
      .bottom-box-value {
        color: #434343;
        text-align: center !important;
        font-size: 0.14rem;
      }
    }
    .list-bottom-box2 {
      width: 20%;
    }
    .list-bottom-box::before {
      content: "";
      position: absolute;
      right: 0;
      top: 0.08rem;
      width: 0.01rem;
      height: 0.26rem;
      background-color: #dce5f5;
    }
    .list-bottom-box:nth-last-of-type(1)::before {
      display: none;
    }
  }
  .list-bottom2 {
    .list-bottom-box:nth-last-of-type(1):before,
    .list-bottom-box:nth-last-of-type(2):before,
    .list-bottom-box:nth-last-of-type(3):before,
    .list-bottom-box:nth-last-of-type(4):before {
      display: none;
    }
  }
}
.list-status {
  display: flex;
  .title-box {
    padding: 0.2rem 0 0;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .list-step {
    width: 25%;
  }
  .list-carInfo {
    width: 100%;
  }
  .list-label {
    padding: 0.1rem 0;
  }
  //.list-step-box {
  //  display: flex;
  //  flex-direction: column;
  //  padding: 0 0.3rem 0 0.5rem;
  //  box-sizing: border-box;
  //  .step-list {
  //    border-radius: 0.1rem;
  //    background: #ffffff;
  //    padding: 0.04rem 0.14rem;
  //    box-sizing: border-box;
  //    margin-bottom: 0.5rem;
  //    position: relative;
  //    .step-date {
  //      font-size: 0.12rem;
  //      height: 0.22rem;
  //    }
  //    .step-content {
  //      font-size: 0.14rem;
  //    }
  //  }
  //  .step-list::before {
  //    content: "";
  //    position: absolute;
  //  }
  //}
  .color8c8c8c {
    color: #8c8c8c;
  }
  .color434343 {
    color: #434343;
  }
  .bgEDF4FF {
    background-color: #edf4ff;
  }
}
.schedule-container {
  padding: 20px;
}
.stats-wrapper {
  margin-bottom: 15px;
}
.stats-wrapper .el-tag {
  margin-right: 10px;
}
.calendar-day {
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 2px 0;
  cursor: pointer;
}
/* 非当月：置灰 + 禁止点击 */
.calendar-day.disabled {
  opacity: 0.3;
  pointer-events: none;
  background: #f5f5f5;
}
.day-num {
  font-weight: bold;
  margin-bottom: 4px;
}
.status {
  display: inline-block;
  padding: 1px 4px;
  font-size: 11px;
  color: #fff;
  border-radius: 3px;
  margin-bottom: 3px;
}
.dispatch {
  font-size: 10px;
  color: #666;
  padding-top: 6px;
}
.wait { background: #e6a23c; }
.work { background: #67c23a; }
.rest { background: #f56c6c; }
.default { background: #eee; }
::v-deep .el-calendar {
  .el-calendar-table{
    width: 100%;
    height: 100%;
    &:not(.is-range){
      td.next{
        pointer-events: none;
      }
      td.prev{
        pointer-events: none;
      }
    }
  }
}
.dot-detail{
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  .detail-box{
    margin-right: 10px;
    .label-text{
      color: #fff;
      border-radius: 2px;
      padding: 2px 4px;
    }
    .value-text{
      font-size: 16px;
      padding-left: 10px;
    }
  }
  .detail-box:nth-of-type(1){
    margin-right: 1rem;
    .value-text{
     font-size: 0.2rem;
      font-weight: bold;
    }
  }
  .detail-box:nth-of-type(2){
    .label-text{
      background: #67c23a;
    }
  }
  .detail-box:nth-of-type(3){
    .label-text{
      background: #f56c6c;
    }
  }
  .detail-box:nth-of-type(4){
    .label-text{
      background: #e6a23c;
    }
  }
}
</style>
